import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";
import React, { useState } from "react";
import { useLang } from "./i18n";

export default function ContactUs() {
  const { t } = useLang();
  const [copied, setCopied] = useState(false);
  const email = "support@obto.co";

  const handleCopy = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" className="rounded-full px-4 py-2">
          {t.contactUs}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md text-center">
        <DialogHeader>
          <DialogTitle>{t.contactTitle}</DialogTitle>
        </DialogHeader>
        <p className="mt-2 text-gray-600">{t.contactBody}</p>
        <div className="mt-4 flex items-center justify-center gap-2">
          <span className="font-semibold">{email}</span>
          <Button variant="ghost" size="icon" onClick={handleCopy} aria-label={t.copy}>
            <Copy className="h-4 w-4" />
          </Button>
        </div>
        {copied && <p className="text-green-500 mt-2">{t.copied}</p>}
      </DialogContent>
    </Dialog>
  );
}
